import React from 'react';

const ShareIcon = (props?: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
      <g clipPath="url(#clip0_7645_124659)">
        <path
          d="M10.5 4.66797C11.4665 4.66797 12.25 3.88447 12.25 2.91797C12.25 1.95147 11.4665 1.16797 10.5 1.16797C9.5335 1.16797 8.75 1.95147 8.75 2.91797C8.75 3.88447 9.5335 4.66797 10.5 4.66797Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 8.75C4.4665 8.75 5.25 7.9665 5.25 7C5.25 6.0335 4.4665 5.25 3.5 5.25C2.5335 5.25 1.75 6.0335 1.75 7C1.75 7.9665 2.5335 8.75 3.5 8.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 12.832C11.4665 12.832 12.25 12.0485 12.25 11.082C12.25 10.1155 11.4665 9.33203 10.5 9.33203C9.5335 9.33203 8.75 10.1155 8.75 11.082C8.75 12.0485 9.5335 12.832 10.5 12.832Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.01172 7.87891L8.99589 10.2006"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.99005 3.79688L5.01172 6.11854"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7645_124659">
          <rect width="14" height="14" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ShareIcon;
